import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  TextField,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const DialogButton = styled(Button)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '25px',
    backgroundColor: '#FFFFFF',
    minWidth: '760px',
  },
}));

export const DialogContainer = styled(Box)(() => ({
  padding: '50px',
}));

export const TopBox = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row-reverse',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  margin: '-20px -30px',
  '& span': {
    fontSize: '24px',
    fontWeight: '600',
    color: theme.palette.secondary.main,
  },
}));

export const StyledTitle = styled(DialogTitle)(({ theme }) => ({
  color: '#595959',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  fontSize: '21px',
  fontWeight: '600',
  padding: '0',
  marginBottom: '30px',
  textTransform: 'uppercase',
  '& span': { color: theme.palette.secondary.main },
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  textTransform: 'lowercase',
  marginLeft: 'auto',
  marginTop: '12px',
  backgroundColor: theme.palette.secondary.main,
  '&:hover': {
    filter: 'brightness(85%)',
  },
}));

export const FormStyled = styled(Box)(() => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
}));

export const TextFieldStyled = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '16px',
    '&.Mui-focused label': {
      color: '#595959',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #595959',
    },
  },
  '& .MuiInputLabel-root': {
    color: '#595959',
  },
  '& .MuiSvgIcon-root': {
    color: theme.palette.primary.main,
    fontSize: '36px',
  },
}));
